/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
import acl from "@/acl/acl";
import firebase from "firebase/app";
import "firebase/auth";

Vue.use(Router);
var def = "/dashboard/analytics";
let userInfo = JSON.parse(localStorage.getItem("userInfo"));
if (userInfo && userInfo.userRole === "post") {
  def = "/dashboard/Recruiter";
} else if (userInfo && userInfo.userRole === "admin") {
  def = "/dashboard/CollegePlacement";
}

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,

  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/",
          redirect: def
        },
        {
          path: "/dashboard/analytics",
          name: "dashboard-analytics",
          component: () => import("./views/DashboardAnalytics.vue"),
          meta: {
            rule: "editor",
            //rule:'post',
            authRequired: true
          }
        },
        {
          path: "/pages/FAQ",
          name: "faq",
          component: () => import("./views/FAQ.vue"),
          meta: {
            rule: "editor",
            //rule:'post',
            authRequired: true
          }
        },

        // =============================================================================
        // Application Routes
        // =============================================================================

        //chat for student
        {
          path: "/apps/chat",
          name: "chat",
          component: () => import("./views/apps/chat/Chat.vue"),
          meta: {
            rule: "editor",
            no_scroll: true
          }
        },
        //chat for recruiter
        {
          path: "/apps/conversations",
          name: "conversations",
          component: () => import("./views/apps/chat/Chat.vue"),
          meta: {
            rule: "post",
            no_scroll: true
          }
        },

        {
          path: "/apps/chats",
          name: "conversation",
          component: () => import("./views/apps/chat/Chat.vue"),
          meta: {
            rule: "hr",
            no_scroll: true
          }
        },
        {
          path: "/apps/contact",
          name: "contact",
          component: () => import("./views/apps/chat/Chat.vue"),
          meta: {
            rule: "admin",
            no_scroll: true
          }
        },
        {
          path: "/apps/chat-user",
          name: "contacts",
          component: () => import("./views/apps/chat/Chat.vue"),
          meta: {
            rule: "trp",
            no_scroll: true
          }
        },

        //calendar for student
        {
          path: "/apps/calendar-events",
          name: "calendar",
          component: () => import("./views/apps/calendar/SimpleCalendar.vue"),
          meta: {
            rule: "editor",
            no_scroll: true
          }
        },
        //calendar for tpo
        {
          path: "/apps/calendar",
          name: "calendar-tpo",
          component: () => import("./views/apps/calendar/SimpleCalendar.vue"),
          meta: {
            rule: "admin",
            no_scroll: true
          }
        },
        // calendar for trp
        {
          path: "/apps/calendar-user",
          name: "calendar-TRP",
          component: () => import("./views/apps/calendar/SimpleCalendar.vue"),
          meta: {
            rule: "trp",
            no_scroll: true
          }
        },
        {
          path: "/apps/calendarEvents",
          name: "calendar-recruiter",
          component: () => import("./views/apps/calendar/SimpleCalendar.vue"),
          meta: {
            rule: "post",
            no_scroll: true
          }
        },
        {
          path: "/apps/calendardetails",
          name: "hr-recruiter",
          component: () => import("./views/apps/calendar/SimpleCalendar.vue"),
          meta: {
            rule: "hr",
            no_scroll: true
          }
        },
        {
          path: "/dashboard/change-current-password",
          name: "Change-Current-Password",
          component: () => import("./views/pages/ChangePassword.vue"),
          meta: {
            rule: "admin"
          }
        },

        // =============================================================================
        // Student  Routes
        // =============================================================================

        {
          path: "/dashboard/ChangePassword",
          name: "ChangePassword",
          component: () => import("./views/pages/ChangePassword.vue"),
          meta: {
            rule: "editor"
          }
        },

        // {
        //     path: '/dashboard/MyProfile',
        //     name: 'myprofile',
        //     component: () => import('./views/student/MyProfile.vue'),
        //     meta: {
        //         rule: 'editor'
        //     }
        // },

        // =============================================================================
        // Recruiter  Routes
        // =============================================================================
        {
          path: "/dashboard/Change-Password",
          name: "Change-Password",
          component: () => import("./views/pages/ChangePassword.vue"),
          meta: {
            rule: "post",
            no_scroll: true
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        /* {
                    path: '/callback',
                    name: 'auth-callback',
                    component: () => import('@/views/Callback.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },*/
        {
          path: "/pages/login",
          name: "page-login",
          component: () => import("@/views/pages/login/Login.vue"),
          meta: {
            rule: "editor"
          }
        },

        {
          path: "/pages/register",
          name: "page-register",
          component: () => import("@/views/pages/register/Register.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/pages/forgot-password",
          name: "page-forgot-password",
          component: () => import("@/views/pages/ForgotPassword.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/pages/reset-password",
          name: "page-reset-password",
          component: () => import("@/views/pages/ResetPassword.vue"),
          meta: {
            rule: "editor"
          }
        },

        ////landing pages routes----/////
        ////////////--------------------////////////
        {
          path: "/pages/lock-screen",
          name: "page-lock-screen",
          component: () => import("@/views/pages/LockScreen.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/pages/comingsoon",
          name: "page-coming-soon",
          component: () => import("@/views/pages/ComingSoon.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/pages/error-500",
          name: "page-error-500",
          component: () => import("@/views/pages/Error500.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/pages/not-authorized",
          name: "page-not-authorized",
          component: () => import("@/views/pages/NotAuthorized.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/pages/maintenance",
          name: "page-maintenance",
          component: () => import("@/views/pages/Maintenance.vue"),
          meta: {
            rule: "editor"
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(() => {
    // get firebase current user
    const firebaseCurrentUser = firebase.auth().currentUser;

    // if (
    /*to.path === "/home" ||
                to.path === "/student" ||
                to.path === "/institute" ||
                to.path === "/recruiter" ||
                to.path === "/contact-us" ||
                to.path === "/About" ||
                to.path === "/privacypolicy" ||
                to.path === "/request_Demo" ||
                to.path === "/pages/registerrecruiter" ||*/
    //     to.path === "/pages/login" ||
    //     to.path === "/pages/forgot-password" ||
    //     to.path === "/pages/error-404" ||
    //     to.path === "/pages/error-500" ||
    //     to.path === "/pages/register" ||
    //     to.path === "/callback" ||
    //     to.path === "/pages/comingsoon" ||
    //     (auth.isAuthenticated() || firebaseCurrentUser)
    // ) {
    //     return next();
    // }

    // If auth required, check login. If login fails redirect to login page
    if (to.meta.authRequired) {
      if (!firebaseCurrentUser) {
        router.push({ path: "/pages/login", query: { to: to.path } });
        // router.push({ path: '/home', query: { to: to.path } })
      }
    }

    return next();
    // Specify the current path as the customState parameter, meaning it
    // will be returned to the application after auth
    // auth.login({ target: to.path });
  });
});

export default router;
